var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlignLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h13v1H0zm0 3h18v1H0zm0 3h14v1H0zm0 3h18v1H0zm0 3h12v1H0z"
})));
export { SvgAlignLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxMyI+PHBhdGggZD0iTTAgMGgxM3YxSDB6TTAgM2gxOHYxSDB6TTAgNmgxNHYxSDB6TTAgOWgxOHYxSDB6TTAgMTJoMTJ2MUgweiIvPjwvc3ZnPgo=";